import {SprintResponseModel} from 'models/sprint.model';
import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setSelectedSprint, sprintSelector} from 'store/sprints/sprintSlice';

export const useSprintsRedux = () => {
    const {selectedSprint: selectedSprintInRedux} = useSelector(sprintSelector);
    const dispatch = useDispatch();
    const selectedSprint = useMemo(() => selectedSprintInRedux, [selectedSprintInRedux]);
    const setSelectedSprintInRedux = useCallback(
        (value: SprintResponseModel | null) => {
            dispatch(setSelectedSprint(value));
        },
        [dispatch],
    );
    return {
        selectedSprint,
        setSelectedSprintInRedux,
    };
};
